/**
 * Date helpers — single source of truth for "what day is it in the user's local time?"
 *
 * THE PROBLEM:
 *   `new Date().toISOString().slice(0, 10)` returns UTC date.
 *   At 9am AEST that's "yesterday" UTC. Used as a date stamp on
 *   timesheet rows / toolbox talks / etc, it lands shifts on the wrong day.
 *
 * THE FIX:
 *   Always use the helpers below for any "today's date" calculation.
 */

/** Returns today's date in the user's LOCAL timezone as 'YYYY-MM-DD'. */
export const localTodayISO = () => {
  const d = new Date();
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
};

/** Returns local YYYY-MM-DD for any Date instance (or ISO string). */
export const localDateISO = (dateLike) => {
  const d = dateLike instanceof Date ? dateLike : new Date(dateLike);
  if (isNaN(d.getTime())) return null;
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
};

/** Returns now as a local YYYY-MM-DDTHH:MM string (for `<input type="datetime-local" max>`). */
export const localNowDatetimeInput = () => {
  const d = new Date();
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};
